/* eslint-disable sort-keys */
import { instancePromotionApi } from './api'

export const getPromocao = ( idAssinatura, idPlano, codigoPromocao, formaPagamento, tipoAssinatura, email ) => {
  const data = {
    'coupon': codigoPromocao,
    'type': tipoAssinatura,
    'plan_id': idPlano,
    'payment_method': formaPagamento,
    'subscription_id': idAssinatura,
    email
  }
  return instancePromotionApi.post( '/coupon/', data )
}
